import { render, staticRenderFns } from "./StatisticItem.vue?vue&type=template&id=c9d164ae&"
import script from "./StatisticItem.vue?vue&type=script&lang=ts&"
export * from "./StatisticItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports